const size = {
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1440px',
};
export default {
  ...size,
};
